import RootState from "~/types/store";

export const ANALYZE_DATA_KEY = "ANALYZE_DATA";

// Batch Zapper Analyze category permission GUIDs
export const SUMMARIZE_SELECTED_ANALYZE_TYPE_GUID = "b1c2d3e4-5f6a-7b8c-9d0e-1f2a3b4c5d6e";
export const AI_CHAT_ANALYZE_TYPE_GUID = "433a8a43-5fe9-48b9-9748-4efc364f485b";

export const getModuleState = (state: RootState): any => state[ANALYZE_DATA_KEY];

export const getAllowedPrompts = (state: RootState) => getModuleState(state).allowedPrompts;

export const getIsSummarizeSelectedAllowed = (state: RootState): boolean => {
    const allowedPrompts = getAllowedPrompts(state);
    if (allowedPrompts === null) {
        return false;
    }
    return allowedPrompts.some(
        (p: { analyzeTypeGuid: string }) =>
            p.analyzeTypeGuid === SUMMARIZE_SELECTED_ANALYZE_TYPE_GUID
    );
};

export const getIsAiChatAllowed = (state: RootState): boolean => {
    const allowedPrompts = getAllowedPrompts(state);
    if (allowedPrompts === null) {
        return false;
    }
    return allowedPrompts.some(
        (p: { analyzeTypeGuid: string }) => p.analyzeTypeGuid === AI_CHAT_ANALYZE_TYPE_GUID
    );
};
